import { render, staticRenderFns } from "./RecordScreen.vue?vue&type=template&id=322eae09&scoped=true"
import script from "./RecordScreen.vue?vue&type=script&lang=js"
export * from "./RecordScreen.vue?vue&type=script&lang=js"
import style0 from "./RecordScreen.vue?vue&type=style&index=0&id=322eae09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322eae09",
  null
  
)

export default component.exports